import { DivMarginTop } from "components/common/style/margin/DivMarginTop";
import styled from "styled-components";
import { useLocalStorageEntry } from "hooks/hook_util/local_storage/useLocalStorageEntry";
import { CHARACTER_EDIT_RELATE } from "constant/character/character.constant";

const CharacterViewSettings = () => {
  const [relateEdit, setRelateEdit] = useLocalStorageEntry(
    CHARACTER_EDIT_RELATE.RELATE_EDIT
  );
  const [relateEditAutosave, setRelateEditAutosave] = useLocalStorageEntry(
    CHARACTER_EDIT_RELATE.RELATE_EDIT_AUTO_SAVE
  );
  const [relateNav, setRelateNav] = useLocalStorageEntry(
    CHARACTER_EDIT_RELATE.RELATE_NAV
  );
  const [editNav, setEditNav] = useLocalStorageEntry(
    CHARACTER_EDIT_RELATE.EDIT_NAV
  );
  const [relateAnswerActionFormMode, setRelateAnswerActionFormMode] =
    useLocalStorageEntry(CHARACTER_EDIT_RELATE.RELATE_ANSWER_ACTION_FORM_MODE);

  const relateEditClickHandle = () => {
    setRelateEdit(relateEdit !== "edit" ? "edit" : "");
  };

  const relateEditAutosaveClickHandle = () => {
    setRelateEditAutosave(relateEditAutosave !== "save" ? "save" : "");
  };

  const relateNavClickHandle = () => {
    setRelateNav(relateNav !== "navigation" ? "navigation" : "");
  };

  const editNavClickHandle = () => {
    setEditNav(editNav !== "edit" ? "edit" : "");
  };

  const relateAnswerActionFormModeClickHandle = () => {
    setRelateAnswerActionFormMode(
      relateAnswerActionFormMode !== "show" ? "show" : ""
    );
  };

  return (
    <DivMarginTop mt={1}>
      <DivMarginTop mt={0}>Character view settings</DivMarginTop>
      <DivSetting
        mt={1}
        active={relateNav === "navigation"}
        onClick={relateNavClickHandle}
      >
        Relate navigation
      </DivSetting>
      <DivSetting
        mt={1}
        active={relateEdit === "edit"}
        onClick={relateEditClickHandle}
      >
        Relate edit
      </DivSetting>
      <DivSetting
        mt={1}
        active={relateEditAutosave === "save"}
        onClick={relateEditAutosaveClickHandle}
      >
        Relate edit autosave
      </DivSetting>
      <DivSetting
        mt={1}
        active={editNav === "edit"}
        onClick={editNavClickHandle}
      >
        Character edit
      </DivSetting>
      <DivSetting
        mt={1}
        active={relateAnswerActionFormMode === "show"}
        onClick={relateAnswerActionFormModeClickHandle}
      >
        Relate answer action form show
      </DivSetting>
    </DivMarginTop>
  );
};

export const DivSetting = styled(DivMarginTop)<{ active?: boolean }>`
  cursor: pointer;
  text-decoration: ${(props: any) => (props.active ? "underline" : "none")};
`;

export default CharacterViewSettings;
